import { Separator } from "@gigpro/ui/Separator";
import { useRequirementForWorksList } from "@sidegigllc/api/client";
import { useWatch } from "react-hook-form";
import { Requirements, type RequirementsProps } from "./Requirements";

const ACCESSORIES_CATEGORY = "Accessories";

/**
 * Accessories requirements shown alongside the Uniform section (CORE-6507), filtered server-side to
 * the Accessories category (CORE-6456). Renders nothing (no separator) when the position has no
 * Accessories requirements.
 */
export function AccessoriesRequirementsFlagged({ form }: Readonly<Omit<RequirementsProps, "category">>) {
  const skillId = useWatch({ control: form.control, name: "skill_id" });
  // Gate on an actual position: with no skill_id the endpoint returns every skill's accessories.
  // Shares the query key with <Requirements category="Accessories"> (no extra request) and only
  // gates rendering. No keepPreviousData — a previous skill's accessories must not render as the
  // current one's while a skill switch is in flight (a toggle then would attach the wrong ids).
  const { data: accessories } = useRequirementForWorksList(
    { skill_id: skillId, category: ACCESSORIES_CATEGORY },
    { query: { enabled: skillId != null, staleTime: Number.POSITIVE_INFINITY } },
  );

  if (skillId == null || !accessories?.length) return null;

  return (
    <>
      <Separator className="my-1 bg-light-gray" />
      <Requirements form={form} category={ACCESSORIES_CATEGORY} />
    </>
  );
}
